import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

export default function CustomButton(props) {
  return (
    <div>
      <Button
        {...props}
        fullWidth={props.fullWidth}
        disabled={props.loading}
        onClick={() => props.onClick()}
        variant={props.variant || "text"}
        size={props.size || "small"}
        sx={{
          px:1,
          fontSize: props.fontSize || 14,
          textTransform: 'none',
          ...((props.shadow=="true") && {
            boxShadow: '0 0 4px rgba(0,0,0,0.20)',
          }),
          color: '#050a4e',
          ...((props.active) && {
            backgroundColor: '#1778f2',
            color: 'white',
            borderColor: '#005cbf',
            ':hover': {
              backgroundColor: '#0069d9'
            },
            ':disabled': {
              color: 'white',
            },
          }),
          ...(props.sx)
        }}
      >
        {props.title}
      </Button>
    </div>
  )
}

CustomButton.propTypes = {
  shadow: PropTypes.string,
  active: PropTypes.bool,
  loading: PropTypes.bool,
  title: PropTypes.string,
  fullWidth: PropTypes.bool,
  onClick: PropTypes.func
};
CustomButton.defaultProps = {
  shadow: "true",
  active: false,
  loading: false,
  fullWidth: false
}
